import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatSidenavModule } from '@angular/material/sidenav';
import { TermsComponent } from '@apps/gc-network/modules/terms/terms.component';
import {
  MainMenuBarModule,
  MipLoadingModule,
  SideMenuModule,
  TopMenuBarModule
} from '@lib/gc-common';
import { TranslateModule } from '@ngx-translate/core';

import { NetworkRoutingModule } from "./network-routing.module";
import { NetworkComponent } from "./network.component";

@NgModule({
  declarations: [NetworkComponent, TermsComponent],
  imports: [CommonModule, NetworkRoutingModule, MainMenuBarModule, MipLoadingModule, TranslateModule, MatSidenavModule, SideMenuModule, TopMenuBarModule],
})
export class NetworkModule {}
